import * as Headless from '@headlessui/react';
import clsx from 'clsx';
import type React from 'react';

export function Popover(props: Headless.PopoverProps) {
  return <Headless.Popover {...props} />;
}

export function PopoverButton<T extends React.ElementType = 'button'>({
  as,
  ...props
}: { className?: string } & Omit<Headless.PopoverButtonProps<T>, 'className'>) {
  return <Headless.PopoverButton as={as} {...props} />;
}

export function PopoverPanel({
  anchor = 'bottom',
  className,
  ...props
}: { className?: string } & Omit<Headless.PopoverPanelProps, 'as' | 'className'>) {
  return (
    <Headless.PopoverPanel
      {...props}
      transition
      anchor={anchor}
      className={clsx(
        className,
        // Anchor positioning
        '[--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(1)]',
        // Base styles
        'isolate z-50 w-max rounded-md',
        // Invisible border that is only visible in `forced-colors` mode for accessibility purposes
        'outline outline-transparent focus:outline-hidden',
        // Handle scrolling when panel won't fit in viewport
        'overflow-y-auto',
        // Popover background
        'bg-popover/75 backdrop-blur-xl',
        // Shadows
        'shadow-xl ring-1 ring-border dark:shadow-[0_10px_40px_rgba(0,0,0,0.7)] dark:ring-inset',
        // Transitions
        'transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0'
      )}
    />
  );
}
